export default __webpack_public_path__ + "static/media/boat.af5fce62.png";